const CryptoJS = require("crypto-js");

function hex2a(hexx) {
    const hex = hexx.toString(); // force conversion
    let str = "";
    for (let i = 0; i < hex.length; i += 2) {
        str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
    }
    return str;
}

function encrypt(msg, pass) {
    const iv = CryptoJS.lib.WordArray.random(16);
    const encrypted = CryptoJS.AES.encrypt(msg, CryptoJS.enc.Utf8.parse(pass), {
        iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC,
        blocksize: 8,
    });

    return btoa(hex2a(iv.toString()) + hex2a(encrypted.ciphertext.toString()));
}

export default encrypt;
